import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F2AC4968-73F6-4D91-BF2B-D8653E6863E2
 * name projector-screen-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/projector-screen-outline.svg
 * tags
 * - Home Automation 
 */
export const ProjectorScreenOutlineIcon = createSvgIcon(<><path d="M20 2H4C3.45 2 3 2.45 3 3V4C3 4.55 3.45 5 4 5H5V14H11V16.59L6.79 20.79L8.21 22.21L11 19.41V22H13V19.41L15.79 22.21L17.21 20.79L13 16.59V14H19V5H20C20.55 5 21 4.55 21 4V3C21 2.45 20.55 2 20 2M17 12H7V5H17V12Z" /></>, 'ProjectorScreenOutlineIcon');
export default ProjectorScreenOutlineIcon